<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.DESCRIPTION' | translate }}
  </div>
  <glxy-alert type="info">
    <strong>{{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.CAVEAT' | translate }}</strong>
  </glxy-alert>
  <mat-card
    appearance="outlined"
    class="product-list"
    [ngClass]="{ 'product-list--populated-top': (selectedProducts$ | async)?.length !== 0 }"
  >
    <div class="product-list--title">{{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.PRODUCTS' | translate }}</div>
    <div class="flex-container">
      <div class="header">{{ 'COMMON.NAME' | translate }}</div>
      <div class="header right">
        {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.WHOLESALE_COST' | translate }}
      </div>
    </div>
    <div class="product-list--empty" *ngIf="(selectedProducts$ | async)?.length === 0">
      <div><mat-icon class="icon">add_shopping_cart</mat-icon></div>
      <strong class="add-items">
        {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.ADD_TO_ACTIVATE' | translate }}
      </strong>
      <button mat-flat-button color="primary" (click)="openProductSelectorModal()">
        {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.ADD_ITEMS' | translate }}
      </button>
    </div>
    <div class="product-list--container">
      <div *ngFor="let product of selectedProducts$ | async">
        <div class="product-list--item flex-container">
          <span class="product-list--item--row">
            <va-icon
              *ngIf="
                !product.parentRequirements.parentDetails?.iconUrl && !product.parentRequirements.parentDetails?.name;
                else dualIcon
              "
              matListItemAvatar
              [iconName]="product.sharedMarketingInformation.name"
              [iconUrl]="product.sharedMarketingInformation.iconUrl"
              [diameter]="36"
              class="product-list--item--icon"
            ></va-icon>
            <ng-template #dualIcon>
              <div class="dual-icon">
                <va-icon
                  matListItemAvatar
                  [iconUrl]="product.sharedMarketingInformation.iconUrl"
                  [iconName]="product.sharedMarketingInformation.name"
                  [diameter]="36"
                ></va-icon>
                <va-icon
                  matListItemAvatar
                  class="secondary-icon"
                  [iconUrl]="product.parentRequirements.parentDetails.iconUrl"
                  [diameter]="18"
                  [iconName]="product.parentRequirements.parentDetails.name"
                ></va-icon>
              </div>
            </ng-template>
            <span>
              <span class="flex-container">
                <div
                  class="product-list--item--name"
                  [ngClass]="{
                    'product-list--item--name-space': !!product.sharedMarketingInformation.editionName
                  }"
                >
                  {{ product.sharedMarketingInformation.name }}
                </div>
                <ng-container *ngIf="!!product.sharedMarketingInformation.editionName">
                  ({{ product.sharedMarketingInformation.editionName }})
                </ng-container>
              </span>
              <div class="product-list--item--type">{{ toProductType(product.appType) }}</div>
            </span>
          </span>
          <span class="product-list--item--row">
            <span *ngIf="appPriceDictionary">
              <billing-ui-simple-price-display
                [currencyCode]="appPriceDictionary[product?.key?.appId]?.currency"
                [price]="appPriceDictionary[product?.key?.appId]?.pricing"
                [frequency]="appPriceDictionary[product?.key?.appId]?.frequency"
                [commitment]="appPriceDictionary[product?.key?.appId]?.commitment"
                topLabel="starting-at"
                align="end"
              ></billing-ui-simple-price-display>
            </span>
            <mat-icon class="product-list--item--remove" (click)="removeProduct(product)">close</mat-icon>
          </span>
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card
    appearance="outlined"
    class="product-list--populated-bottom"
    *ngIf="(selectedProducts$ | async)?.length !== 0"
  >
    <button mat-flat-button color="primary" (click)="openProductSelectorModal()">
      {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_PRODUCT.ADD_ITEMS' | translate }}
    </button>
  </mat-card>
  <div class="product-list--total right" *ngIf="(selectedProducts$ | async)?.length !== 0">
    <span>
      <span class="product-list--total-sum">{{ 'COMMON.PRICING.TOTAL' | translate }}:&nbsp;</span>
      <billing-ui-simple-price-display
        [price]="total"
        frequency="One Time"
        align="end"
        class="product-list--total-sum"
      ></billing-ui-simple-price-display>
    </span>
    <div *ngFor="let charge of recurringTotals$ | async | keyvalue; let first = first">
      <div *ngIf="charge.value.total > 0">
        <billing-ui-simple-price-display
          [price]="charge.value.total"
          [frequency]="charge.value.frequency"
          [currencyCode]="'USD'"
          [componentTextLength]="'verbose'"
          [topLabel]="charge.value.isStartingPrice ? 'starting-at' : null"
          align="end"
        ></billing-ui-simple-price-display>
      </div>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="activation-limit">
      <div class="activation-limit--title">
        {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.PREPROCESSOR.TITLE' | translate }}
      </div>
      <div>{{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.PREPROCESSOR.DESCRIPTION' | translate }}</div>
      <div>
        <glxy-form-field class="activation-limit--input" bottomSpacing="none" [showLabel]="false">
          <input type="number" formControlName="frequency" min="1" max="500" matInput />
        </glxy-form-field>
        {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.PREPROCESSOR.TIMES_WITHIN' | translate }}
      </div>
      <mat-error *ngIf="form.controls.frequency.hasError('pattern')">
        {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.PREPROCESSOR.OUT_OF_BOUNDS' | translate }}
      </mat-error>
      <div>
        <glxy-form-field class="activation-limit--input" bottomSpacing="none" [showLabel]="false">
          <input type="number" formControlName="length" min="1" max="100" matInput />
        </glxy-form-field>
        <glxy-form-field class="activation-limit--select" bottomSpacing="none" [showLabel]="false">
          <mat-select formControlName="period">
            <mat-option [value]="periodHours">
              {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.ACTIVITY.HOURS' | translate }}
            </mat-option>
            <mat-option [value]="periodDays">
              {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.ACTIVITY.DAYS' | translate }}
            </mat-option>
          </mat-select>
        </glxy-form-field>
      </div>
      <mat-error *ngIf="form.controls.length.hasError('pattern')">
        {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.OUT_OF_BOUNDS' | translate }}
      </mat-error>
      <mat-error *ngIf="form.controls.period.hasError('invalid')">
        {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.PERIOD_INVALID' | translate }}
      </mat-error>
    </div>
  </form>
</div>
